module.exports = __webpack_public_path__ + "static/call-to-action-image-getting-started-936c0d5c12b81be05f903fd276ecd381.jpg";